class SmartcapZpScroll extends HTMLElement {
  connectedCallback() {
    this._init();
    this._onSectionLoad = (event) => {
      const section = this.closest(`#shopify-section-${event.detail.sectionId}`);
      if (!section) return;
      this._init();
    };
    document.addEventListener('shopify:section:load', this._onSectionLoad);
  }

  disconnectedCallback() {
    if (this._observer) this._observer.disconnect();
    document.removeEventListener('shopify:section:load', this._onSectionLoad);
  }

  _init() {
  if (this._observer) this._observer.disconnect();

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    this.querySelectorAll('[data-zp-row]').forEach(row => {
      row.classList.add('sc-zp__row--visible');
    });
    return;
  }

  const rows = this.querySelectorAll('[data-zp-row]');
  if (!rows.length) return;

  /* ADD — small delay so rows start hidden before observer fires */
  setTimeout(() => {
    this._observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('sc-zp__row--visible');
          this._observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });

    rows.forEach(row => this._observer.observe(row));
  }, 100);
}
}

if (!customElements.get('smartcap-zp-scroll')) {
  customElements.define('smartcap-zp-scroll', SmartcapZpScroll);
}